export class Trabalhodenunciante{

  id: number;
  local: string;
  servicoDepto: string;
  cargo: string;
  tempoCargo: string;
  funcao: string;
  tempoFuncao: string;
  jornada: string;
  tempoServicoInst: string;
  contratotrabalho_id: number;
  
}



// WEBPACK FOOTER //
// ./src/app/entrevistas/trabalhodenunciante.ts